import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateBase1001Component } from '../../base-1001-certificate';

@Component({
  selector: 'authority-labs-certificate-ventilation-system-and-fire-protection',
  templateUrl:
    './certificate-ventilation-system-and-fire-protection.component.html',
  styleUrls: [
    './certificate-ventilation-system-and-fire-protection.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateVentilationSystemAndFireProtectionComponent extends CertificateBase1001Component {
  systemDescription = `מערכת אוורור והגנה מפני אש במערכות בישול מסחריות`;
  // systemDescription = `בדיקת תכנון, תוכניות והתאמת התקנת מערכת מיזוג אוויר ואוורור לנדרש תחת ת"י 1001 חלק 6 - "בטיחות אש בבניינים: אוורור והגנה מפני אש במערכות בישול מסחריות" מהדורת נובמבר 2018 בלבד`;
}
